"use client";

import { useEffect, useRef } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { openCbgManageCookies } from "@/utilities/openCbgManageCookies";

/**
 * Opens the Carlsberg cookie UI when the page loads with `?cbgManage=true`
 * (for example from a bookmark or no-JS fallback link).
 */
export function CbgManageCookiesHandler() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const handledRef = useRef(false);

  useEffect(() => {
    if (searchParams.get("cbgManage") !== "true") {
      handledRef.current = false;
      return;
    }

    if (handledRef.current) return;
    handledRef.current = true;

    openCbgManageCookies();

    const nextParams = new URLSearchParams(searchParams.toString());
    nextParams.delete("cbgManage");
    const nextQuery = nextParams.toString();
    router.replace(nextQuery ? `${pathname}?${nextQuery}` : pathname, {
      scroll: false,
    });
  }, [pathname, router, searchParams]);

  return null;
}
